import React, { lazy, Suspense, useEffect, useState } from "react";
import VideoOverlay from './VideoOverlay';
import ShortsSection from './ShortsSection';
import Footer from '../../common/UI/Footer';
import Videoscategories from './VideosCategories';
import { Helmet } from 'react-helmet'; // ✅ Import Helmet
import { getPageMetaById } from '../../api/PageMetaManager';

export default function VideoMainPage() {

  const [meta, setMeta] = useState({
    title: "",
    description: "",
    keywords: ""
  });

  useEffect(() => {
    const fetchMeta = async () => {
      try {
        const data = await getPageMetaById(8);
        setMeta({
          title: data.meta_title || '',
          description: data.meta_description || '',
          keywords: data.meta_keywords || ''
        });
      } catch (error) {
        console.warn('Meta not found for home page, using defaults');
      }
    };

    fetchMeta();
  }, []);
  

  return (
    <>
      {/* ✅ Set the tab title */}
      <Helmet>
        <title>{meta.title || 'Watch Videos - SunoKahaniyan'}</title>
        <meta
          name="description"
          content={
            meta.description ||
            'Explore documentaries, kids content, and shorts on SunoKahaniyan.'
          }
        />
        <meta name="keywords" content={meta.keywords || 'audio stories, ebooks, videos, hindi kahaniyan, suno kahaniyan'} />
      </Helmet>
      <VideoOverlay />
      <Videoscategories title="Documentaries" />
      <Videoscategories title="Kid" />

      <Footer />
    </>
  );
}
